import React from 'react';
import { GraduationCap, ClipboardCheck, Sparkles } from 'lucide-react';

export const TRAINING_CATEGORY_LABELS = {
  obrigatorio: 'Obrigatório (NRs)',
  seguranca: 'Segurança do Trabalho',
  integracao: 'Integração',
  comportamental: 'Comportamental',
  tecnico: 'Técnico',
};

export const GROUPS = {
  treinamento: {
    label: 'Treinamentos',
    hint: 'Capacitação necessária para o cargo',
    icon: GraduationCap,
    box: 'border-purple-200 bg-purple-50/60',
    title: 'text-purple-800',
    chip: 'bg-purple-100 text-purple-800',
  },
  requisito: {
    label: 'Requisitos do Cargo',
    hint: 'Formação, experiência, habilitações',
    icon: ClipboardCheck,
    box: 'border-amber-200 bg-amber-50/60',
    title: 'text-amber-800',
    chip: 'bg-amber-100 text-amber-800',
  },
  competencia: {
    label: 'Habilidades e Competências',
    hint: 'Comportamentos e capacidades esperadas',
    icon: Sparkles,
    box: 'border-teal-200 bg-teal-50/60',
    title: 'text-teal-800',
    chip: 'bg-teal-100 text-teal-800',
  },
};

export const GroupBlock = ({ group, items, testId, renderMeta }) => {
  const g = GROUPS[group];
  const Icon = g.icon;
  return (
    <div className={`rounded-xl border p-4 ${g.box}`} data-testid={testId}>
      <div className="flex items-center gap-2 mb-1">
        <Icon className={`w-4 h-4 ${g.title}`} />
        <h4 className={`font-semibold text-sm ${g.title}`}>{g.label}</h4>
        <span className={`ml-auto text-xs px-2 py-0.5 rounded-full ${g.chip}`}>{items.length}</span>
      </div>
      <p className="text-[11px] text-slate-500 mb-3">{g.hint}</p>
      {items.length === 0 ? (
        <p className="text-xs text-slate-400 italic">Nenhum item</p>
      ) : (
        <ul className="space-y-1.5">
          {items.map((it, i) => (
            <li key={`${it.nome}-${i}`} className="text-sm text-slate-800 bg-white/80 rounded-md px-2 py-1.5 border border-white">
              {it.nome}
              {renderMeta && <span className="block text-[11px] text-slate-500">{renderMeta(it)}</span>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
